import { ResponseCartOneTimeFeeModel, ResponseCartMonthlyRecurringFeeModel, ResponseCartTotalAmountInfoModel } from './index';

  export class ResponsePriceInfoModel {
      oneTimeFee: ResponseCartOneTimeFeeModel[];
      monthlyRecurringFee: ResponseCartMonthlyRecurringFeeModel;
      totalAmount: ResponseCartTotalAmountInfoModel;
}
